module.exports = __webpack_public_path__ + "assets/normal/images/icon-left.73397cf2.png";